import * as R from 'ramda';
import { franc as francMin } from 'franc-min';
import { isEmptyOrNil } from 'core/helpers';
import { keyboardLayoutsMappingCollection, gamesSearchAvailableLanguages } from '../constants';

const changeSymbolsLanguage = (value, language) => {
  const currentKeyboard = keyboardLayoutsMappingCollection[language] || {};

  const switchedValue = R.unless(
    isEmptyOrNil,
    R.always(
      R.compose(
        R.join(''),
        R.map(char => currentKeyboard[char] || char),
        R.split(''),
      )(value)
    )
  )(currentKeyboard);

  return { switchedValue, defaultValue: value };
};

export const switchLanguageSymbols = (value) => {
  const defaultResult = { switchedValue: value, defaultValue: value };

  if (isEmptyOrNil(value)) {
    return defaultResult;
  }

  const currentKeyboardLanguage = francMin(value, { minLength: 1, only: gamesSearchAvailableLanguages });

  const isAvailableLanguage = R.includes(currentKeyboardLanguage, gamesSearchAvailableLanguages);

  return isAvailableLanguage
    ? changeSymbolsLanguage(value, currentKeyboardLanguage)
    : defaultResult;
};
